/**
 * Bootstrap our game - this component uses a componentDidMount event to kick everything in to life
 * @author Carl Trelfa
 */
import React from 'react'
import app from './koko-framework/app'
import main from './main'
import MoreInfo from './MoreInfo'
import { au } from './koko-framework/shorthand'
import ShareHtmlPop from './ShareHtmlPop'

export const moreInfoController = {};

export default class Bootstrap extends React.Component {
    constructor(props) {
        super(props);
        // this.pixi_cnt = React.createRef();
        this.bootstrapped = false;
        this.state = {moreInfoOpen: false, fadeOutMoreInfo: false, sharePopOpen: false, fadeOutSharePop: false, fadeInPop: false};

        moreInfoController.showMoreInfo = this.showMoreInfo;
        moreInfoController.hideMoreInfo = this.hideMoreInfo;
        moreInfoController.showSharePop = this.showSharePop;
        moreInfoController.hideSharePop = this.hideSharePop;
    }

    showMoreInfo = () => {
        this.setState({moreInfoOpen: true, fadeOutMoreInfo: false, fadeInPop: false});
        setTimeout(this.fadeInPop, 10);
    }

    hideMoreInfo = () => {
        if (this.state.moreInfoOpen === true && this.state.fadeOutMoreInfo === false) {
            au.play('button', 1, false);
            this.setState({fadeOutMoreInfo: true, fadeInPop: false});
            setTimeout(this.moreInfoHidden, 400);
        }
    }

    moreInfoHidden = () => {
        this.setState({moreInfoOpen: false, fadeOutMoreInfo: false});
        if (moreInfoController.hiddenCallback) {
            moreInfoController.hiddenCallback();
        }
    }

    showSharePop = () => {
        this.setState({sharePopOpen: true, fadeOutSharePop: false, fadeInPop: false});
        setTimeout(this.fadeInPop, 10);
    }

    hideSharePop = () => {
        if (this.state.sharePopOpen === true && this.state.fadeOutSharePop === false) {
            au.play('button', 1, false);
            this.setState({fadeOutSharePop: true, fadeInPop: false});
            setTimeout(this.sharePopHidden, 400);
        }
    }

    sharePopHidden = () => {
        this.setState({sharePopOpen: false, fadeOutSharePop: false});
        if (moreInfoController.hiddenCallback) {
            moreInfoController.hiddenCallback();
        }
    }

    fadeInPop = () => {
        this.setState({fadeInPop: true});
    }

    componentDidMount() {
        if (!this.bootstrapped) {
            // set it going
            window.deviceWidth = window.innerWidth;
	        window.deviceHeight = window.innerHeight;

            // you can set gui size and other stuff here
            app.assetsBase = './';
            app.bgColor = 0xF9EDDF;
            app.guiSize = { width: 765, height:1355 };
            app.minSize = { width: 620, height:1080/*850*/ };
    	    app.anti_alias = true;
	        app.retina = true;
	        app.roundPixels = false;        
	        app.forceFXAA = false;
            app.autoDensity = true;

	        app.init();
	        app.setupComplete = function() {
    		    main.init();
	    	    app.resize();
	        }
            app.loaded();
            app.appendRenderer();

            // I tried to get the renderer appended to a specific div, but that didn't seem to work
            // So I stuck with appending it before the first child on the body class
            // Prob needs changing really
            // console.log('state: ', this.state);
            // if (this.state.renderer != app.renderer) {
                // this.setState({appView: app.renderer.renderer.view});
            // } else {
                // this.updatePixiCnt(this.pixi_cnt);
            // }
            // this.pixi_cnt.appendChild(app.renderer.renderer.view);

            const imagesPreload = ['./img/BG_pattern.jpg', './img/sp_carrier.png', './img/moreinfo_title.png', './img/fb_btn.png', './img/twitter_btn.png'];
            imagesPreload.forEach((image) => {
                const newImage = new Image();
                newImage.src = image;
                window[image] = newImage;
            });

            this.bootstrapped = true;
        }
    }

    // canvas will be attached inside our game-div
    // will probably need some css, depending on your needs
    render() {
        return (
            <>
                {this.state.moreInfoOpen && <MoreInfo open={this.state.moreInfoOpen} fadeOut={this.state.fadeOutMoreInfo} fadeIn={this.state.fadeInPop} />}
                {this.state.sharePopOpen && <ShareHtmlPop open={this.state.sharePopOpen} fadeOut={this.state.fadeOutSharePop} fadeIn={this.state.fadeInPop} />}
                <div className="rotate-device-bg" />
                <div className="rotate-device" />
            </>
        );
    }
}
